export type CourseType = "SwimmingLessonSemester" | "SwimmingLessonDynamic";

export enum AcademyGroupingVariant {
  ByLanes = "ByLanes",
  ByAssortmentGroups = "ByAssortmentGroups",
  ByInstructors = "ByInstructors",
}

export const ACADEMY_GROUPING_VARIANT_OPTIONS: { value: AcademyGroupingVariant; label: string }[] = [
  { value: AcademyGroupingVariant.ByLanes, label: "Grupowanie po torach" },
  { value: AcademyGroupingVariant.ByAssortmentGroups, label: "Grupowanie po grupach zajęciowych" },
  { value: AcademyGroupingVariant.ByInstructors, label: "Grupowanie po instruktorach" },
];

export interface SwimmingInstructor {
  objectId: number;
  objectDb: number;
  name: string;
  lastName: string;
  picture?: string;
}

export interface SwimmingExerciseGroup {
  objectId: number;
  objectDb: number;
  displayName: string;
}

export interface SwimmingLesson {
  objectId: number;
  objectDb: number;
  status?: string;
  name: string;
  capacity: number;
  reserved: number;
  prereservation?: number;
  /** ms timestamp (Java Date) */
  startTime: number;
  /** ms timestamp (Java Date) */
  closeTime: number;
  saleFrom?: number;
  saleTo?: number;
  human?: { objectId: number; objectDb: number; displayName?: string };
  exerciseGroup?: { objectId: number; objectDb: number; displayName?: string };
  buttonCollor?: string;
  description?: string;
  waitListQuantity?: number;
  location: string;
  eventMessage?: string;
  imageUrl?: string;
  /** "HH:mm" — ExerciseTablePOJO.startTime_str */
  startTime_str: string;
  /** "HH:mm" — ExerciseTablePOJO.closeTime_str */
  closeTime_str: string;
  humanName?: string;
  humanLastName?: string;
  exerciseGroupName?: string;
  waitListPosition?: number;
  waitListCount?: number;
  courseType: string;
  lowestPrice?: number;
  humanPicture?: string;
  deputyHumanPicture?: string;
  deputyHumanName?: string;
  deputyHumanLastName?: string;
}

export interface SwimmingScheduleData {
  locations: string[];
  lessons: SwimmingLesson[];
  /** API field: "trainers" */
  trainers: SwimmingInstructor[];
  /** API field: "groups" */
  groups: SwimmingExerciseGroup[];
}

export interface SwimmingFilters {
  onlyAvailable: boolean;
  /** ID in "objectDb,objectId" format, or "" for all */
  instructor: string;
  /** IDs in "objectDb,objectId" format */
  exerciseGroups: string[];
  courseType: CourseType | "ALL";
  locations: string[];
  groupingVariant: AcademyGroupingVariant;
}
